import React, { useState } from 'react';
import { Footer } from '../components/Footer';
import { MerchantCard } from '../components/MerchantCard';
import { SearchIcon, FilterIcon, StoreIcon } from 'lucide-react';
interface Merchant {
  id: number;
  name: string;
  category: string;
  discount: string;
  description?: string;
  logo?: string;
}
const categories = ['Todos', 'Restaurantes y Cafeterías', 'Tiendas y Retail', 'Salud y Bienestar', 'Educación', 'Entretenimiento', 'Servicios', 'Belleza y Estética', 'Tecnología', 'Deportes y Fitness'];
const merchants: Merchant[] = [{
  id: 1,
  name: 'Café Central',
  category: 'Restaurantes y Cafeterías',
  discount: '15% de descuento',
  description: 'Café de especialidad y repostería artesanal'
}, {
  id: 2,
  name: 'Farmacia Salud Plus',
  category: 'Salud y Bienestar',
  discount: '10% en medicamentos',
  description: 'Farmacia con amplio stock de medicamentos y productos de salud'
}, {
  id: 3,
  name: 'Gimnasio FitLife',
  category: 'Deportes y Fitness',
  discount: '20% en membresías',
  description: 'Centro de entrenamiento con equipos de última generación'
}, {
  id: 4,
  name: 'Librería El Saber',
  category: 'Educación',
  discount: '12% en libros',
  description: 'Amplia selección de libros académicos y literatura'
}, {
  id: 5,
  name: 'Restaurante La Tradición',
  category: 'Restaurantes y Cafeterías',
  discount: '15% en consumo total',
  description: 'Comida tradicional ecuatoriana en ambiente familiar'
}, {
  id: 6,
  name: 'Tech Store',
  category: 'Tecnología',
  discount: '10% en accesorios',
  description: 'Tecnología y accesorios para tu día a día'
}, {
  id: 7,
  name: 'Spa Relax',
  category: 'Belleza y Estética',
  discount: '25% en tratamientos',
  description: 'Tratamientos de belleza y relajación'
}, {
  id: 8,
  name: 'Cine Premium',
  category: 'Entretenimiento',
  discount: '2x1 en entradas',
  description: 'Disfruta del mejor cine con sonido envolvente'
}, {
  id: 9,
  name: 'Boutique Moda',
  category: 'Tiendas y Retail',
  discount: '20% en toda la tienda',
  description: 'Moda contemporánea para toda la familia'
}, {
  id: 10,
  name: 'Lavandería Express',
  category: 'Servicios',
  discount: '15% en servicios',
  description: 'Servicio de lavandería rápido y eficiente'
}, {
  id: 11,
  name: 'Pizzería Napoli',
  category: 'Restaurantes y Cafeterías',
  discount: '10% de descuento',
  description: 'Pizzas artesanales al horno de leña'
}, {
  id: 12,
  name: 'Óptica Visión',
  category: 'Salud y Bienestar',
  discount: '15% en lentes',
  description: 'Lentes oftálmicos y de sol de las mejores marcas'
}];
export function MerchantsPage() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [searchTerm, setSearchTerm] = useState('');
  const filteredMerchants = merchants.filter(merchant => {
    const matchesCategory = selectedCategory === 'Todos' || merchant.category === selectedCategory;
    const matchesSearch = merchant.name.toLowerCase().includes(searchTerm.toLowerCase()) || merchant.category.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  return <div className="min-h-screen bg-black" data-id="element-346">
      {/* Hero Section */}
      <section className="relative bg-black text-white py-20 px-6 border-b border-yellow-600/20" data-id="element-347">
        <div className="max-w-6xl mx-auto text-center" data-id="element-348">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-600/20 rounded-full mb-6" data-id="element-349">
            <StoreIcon className="w-10 h-10 text-yellow-400" data-id="element-350" />
          </div>

          <h1 className="text-4xl md:text-6xl font-bold mb-4" data-id="element-351">
            Comercios{' '}
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent" data-id="element-352">
              Afiliados
            </span>
          </h1>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8" data-id="element-353">
            Descubre todos los lugares donde puedes disfrutar de beneficios
            exclusivos con tu SamboCard
          </p>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto relative" data-id="element-354">
            <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-355" />
            <input type="text" placeholder="Buscar comercios..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-12 pr-4 py-4 bg-gray-900 border-2 border-yellow-600/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-yellow-600 focus:ring-1 focus:ring-yellow-600" data-id="element-356" />
          </div>
        </div>
      </section>

      {/* Filters Section */}
      <section className="bg-black py-8 px-6 border-b border-yellow-600/20 sticky top-0 z-40 backdrop-blur-sm bg-black/95" data-id="element-357">
        <div className="max-w-6xl mx-auto" data-id="element-358">
          <div className="flex items-center gap-3 mb-4" data-id="element-359">
            <FilterIcon className="w-5 h-5 text-yellow-400" data-id="element-360" />
            <span className="text-white font-semibold" data-id="element-361">Categorías:</span>
          </div>

          <div className="flex flex-wrap gap-3" data-id="element-362">
            {categories.map(category => <button key={category} onClick={() => setSelectedCategory(category)} className={`px-4 py-2 rounded-lg font-medium transition-all ${selectedCategory === category ? 'bg-yellow-600 text-black' : 'bg-gray-800 text-gray-300 hover:bg-gray-700 border border-yellow-600/20'}`} data-id="element-363">
                {category}
              </button>)}
          </div>
        </div>
      </section>

      {/* Merchants Grid */}
      <section className="bg-black py-16 px-6" data-id="element-364">
        <div className="max-w-6xl mx-auto" data-id="element-365">
          {filteredMerchants.length > 0 ? <>
              <div className="mb-8" data-id="element-366">
                <p className="text-gray-400" data-id="element-367">
                  Mostrando{' '}
                  <span className="text-yellow-400 font-semibold" data-id="element-368">
                    {filteredMerchants.length}
                  </span>{' '}
                  comercios
                  {selectedCategory !== 'Todos' && ` en ${selectedCategory}`}
                </p>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-369">
                {filteredMerchants.map(merchant => <MerchantCard key={merchant.id} name={merchant.name} category={merchant.category} discount={merchant.discount} description={merchant.description} logo={merchant.logo} data-id="element-370" />)}
              </div>
            </> : <div className="text-center py-16" data-id="element-371">
              <p className="text-gray-400 text-lg" data-id="element-372">
                No se encontraron comercios que coincidan con tu búsqueda
              </p>
            </div>}

          {/* CTA Section */}
          <div className="mt-16 text-center" data-id="element-373">
            <div className="inline-block bg-gradient-to-br from-gray-900 to-black border-2 border-yellow-600/30 rounded-2xl p-8 max-w-2xl" data-id="element-374">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-375">
                ¿No encuentras tu comercio favorito?
              </h3>
              <p className="text-gray-300 mb-6" data-id="element-376">
                Invítalo a ser parte de SamboCard y disfruta de beneficios
                exclusivos
              </p>
              <a href="mailto:aliados@sambocard.com" className="inline-block px-8 py-3 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black font-bold rounded-lg hover:from-yellow-500 hover:to-yellow-400 transition-all transform hover:scale-105" data-id="element-377">
                Sugerir Comercio
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-378" />
    </div>;
}